/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureAiGatewayDimensionDetails {
    getFixupPrototypeFunction() { return AzureAiGatewayDimensionDetails.fixupPrototype; }

    static newInstance(model: Partial<AzureAiGatewayDimensionDetails>): AzureAiGatewayDimensionDetails {
        let obj = Object.assign(new AzureAiGatewayDimensionDetails(), model);
        AzureAiGatewayDimensionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureAiGatewayDimensionDetails>): AzureAiGatewayDimensionDetails {
        if (!model) return null;
        return AzureAiGatewayDimensionDetails.newInstance(<AzureAiGatewayDimensionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureAiGatewayDimensionDetails) {
        if (!obj) return;

        models.AzureAiGatewayDimensionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureAiGatewayDimensionDetails): boolean {
        Object.setPrototypeOf(obj, AzureAiGatewayDimensionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Telemetry dimension name carrying the model deployment
     */
    deployment: string;

    /**
     * Telemetry dimension name carrying the billed caller the gateway splits
     */
    parent_caller: string;

    /**
     * Telemetry dimension name carrying the agent id
     */
    agent_id: string;

    /**
     * Telemetry dimension name carrying the agent display name
     */
    agent_name: string;

    /**
     * Telemetry dimension name carrying the gateway subscription id
     */
    subscription_id: string;

    /**
     * Telemetry dimension name carrying packed key=value pairs separated by semicolons
     */
    tags: string;

    /**
     * Request header name carrying a per-conversation id, read from APIM logs only and never stored
     */
    agent_session_id: string;

}
